/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { createContext, useReducer } from 'react';
import { IL10N } from '../../Common/l10n-keys';
import { ArticleTileContextActionType } from '../../Common/enums';

export const ArticleTileContext = createContext({
    l10n: {} as IL10N,
    cdnUrl: '',
    mspOrigin: '',
    setMspOrigin: (origin: string) => {},
    focusFirstTileInNewPage:() => {},
});

function catStateReducer(state, action) {
    if (action.type === ArticleTileContextActionType.SetMspOrigin){
        return {
            mspOrigin: action.payload.mspOrigin,
        };
    }

    return {
        mspOrigin: '',
    };
}

export default function ArticleTileContextProvider(
    props: React.PropsWithChildren<{l10n: IL10N, cdnUrl: string}>) {
    const [catState, catStateDispatch ] = useReducer(catStateReducer, {mspOrigin: ''});

    function setMspOrigin(origin: string) {
        catStateDispatch({type: ArticleTileContextActionType.SetMspOrigin, payload: {mspOrigin: origin}});
    }

    function focusFirstTileInNewPage() {

    }

    const ctxValue = {
        l10n: props.l10n,
        cdnUrl: props.cdnUrl,
        setMspOrigin: setMspOrigin,
        mspOrigin: catState.mspOrigin,
        focusFirstTileInNewPage: focusFirstTileInNewPage,
    };

    return (
        <ArticleTileContext.Provider value={ctxValue}>
            {props.children}
        </ArticleTileContext.Provider>
    );
}
